// extracted by mini-css-extract-plugin
module.exports = {"container":"toggleSignInOrSignUp_container__3MfzG","halfSection":"toggleSignInOrSignUp_halfSection__2nPTu","selectedPlaceholder":"toggleSignInOrSignUp_selectedPlaceholder__SE5dF","selectedPlaceholderBis":"toggleSignInOrSignUp_selectedPlaceholderBis__2Oqpa"};
    if(module.hot) {
      // 1790670304081
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  